import { DOCUMENT_PREFIX } from "common/context/constants"

const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

const sanitazeString = (str = "") => str?.replace(/[^a-z]/gi, "")

export const getCurrentDateFormatted = () => {
  const date = new Date()
  return `${`${date.getDate()}`.padStart(2, "0")}-${`${
    date.getMonth() + 1
  }`.padStart(2, "0")}-${date.getFullYear()}-${`${date.getHours()}`.padStart(
    2,
    "0"
  )}-${`${date.getMinutes()}`.padStart(
    2,
    "0"
  )}-${`${date.getSeconds()}`.padStart(2, "0")}`
}

export const formatDocumentoName = ({
  documentoType = "factura",
  serie,
  numero,
  razonSocial,
  isDocumentoRecibido,
}: $TSMigrationFixMe) =>
  `${DOCUMENT_PREFIX}_${documentoType}_${
    isDocumentoRecibido ? "R" : "E"
  }_(${serie}_${`${numero}`.padStart(4, "0")})_${sanitazeString(
    razonSocial
  )}_(${getCurrentDateFormatted()})`

export function formatBytes(x: $TSMigrationFixMe) {
  let l = 0
  let n = x || 0

  while (n >= 1024) {
    n /= 1024
    l += 1
  }

  return `${Math.ceil(n)} ${units[l]}`
}

export function facturaOcrStringToNumber(str = "") {
  return str?.length ? parseFloat(str.replace(/\./g, "").replace(",", ".")) : 0
}

export const toBase64 = (file: $TSMigrationFixMe) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export const formatSerieAndNumero = ({
  serie = "",
  numero = 1,
}: $TSMigrationFixMe) => {
  let formatedSerie = serie
  if (!serie) {
    return numero
  }
  if (numero) {
    formatedSerie += `-${`${numero}`.padStart(4, "0")}`
  }
  return formatedSerie
}

export const truncateString = ({ str, maxLength = 30 }: $TSMigrationFixMe) => {
  return `${str.substring(0, maxLength)}${str?.length > maxLength ? "..." : ""}`
}

export const removeMimeFromBase64 = (base64 = "") => base64.split(",")[1]

export const getBodyBankAccount = (id = "") => ({
  id,
  iban: null,
  bank: null,
  swift: "",
  principal: false,
  entidadBancariaNombre: "",
  canEditBic: true,
  isNew: true,
})
